import { render, staticRenderFns } from "./DeleteProductModal.vue?vue&type=template&id=5ad205a0&"
import script from "./DeleteProductModal.vue?vue&type=script&lang=js&"
export * from "./DeleteProductModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports